import { Typography } from '@mui/material';
import { ReactNode } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

interface SectionCaptionProps {
  /** Intl message for the section label. Prefer this when the copy is extractable. */
  message?: MessageDescriptor;
  /** Optional values interpolated into `message`. */
  values?: Record<string, string | number>;
  /** Pre-rendered title (e.g. FormattedMessage / translated string). Used when `message` is omitted. */
  title?: ReactNode;
}

/**
 * Uppercase caption heading for a content section (same style as the logger status page).
 */
export function SectionCaption({ message, values, title }: SectionCaptionProps) {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        display: 'block',
        mb: 1.5,
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
      }}
    >
      {message ? <FormattedMessage {...message} values={values} /> : title}
    </Typography>
  );
}
